import { useCallback, memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { Button } from '@cbhq/cds-web/buttons';
import { VStack, HStack } from '@cbhq/cds-web/layout';
import Link from '../shared/Link.js';
import Modal from '../shared/Modal/components/Modal.js';
import { ModalBody } from '../shared/Modal/components/ModalBody.js';
import { ModalContainer } from '../shared/Modal/components/ModalContainer.js';
import { ModalHeader } from '../shared/Modal/components/ModalHeader.js';
import devices from '../shared/styles/devices.js';
import { theme } from '../shared/styles/theme.js';
import Text from '../shared/Text.js';
import '../shared/Toggler/index.js';
import setSigninRedirect from '../shared/utils/setSigninRedirect.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Toggler from '../shared/Toggler/Toggler.js';
const i18nKey = 'MarketingTrackingPreferences.Modal';
const messages = defineMessages({
  title: {
    id: `${i18nKey}.title`,
    defaultMessage: 'Share my Personal Info with third party partners for Advertising',
    description: `
    #Component: LEGACY
    #CharLimit: 115
    #Context: Title of modal prompting user to choose their marketing tracking preferences (CharLimit autocalculated to 115)`
  },
  description: {
    id: `${i18nKey}.description`,
    defaultMessage: 'You are updating your preference for this browser. To update for your account, <a>log in</a> to your account and select Privacy Settings.',
    description: `
    #Component: LEGACY
    #CharLimit: 210
    #Context: Prompting user to update their marketing preference for this browser (CharLimit autocalculated to 210)`
  },
  toggleTitle: {
    id: `${i18nKey}.toggleText`,
    defaultMessage: 'Share My Personal Info with <br></br> third party partners for Advertising',
    description: `
    #Component: LEGACY
    #CharLimit: 130
    #Context: Description of what the toggle does (CharLimit autocalculated to 130)`
  },
  save: {
    id: `${i18nKey}.save`,
    defaultMessage: 'Save',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Button to close modal and save the advertising sharing allowed cookie (CharLimit autocalculated to 35)`
  },
  toggleDescription: {
    id: `${i18nKey}.toggleDescription`,
    defaultMessage: 'Turning this off means we will stop sharing your personal information with our third party partners for advertising purposes. <learnMoreLink>Learn more</learnMoreLink>',
    description: `
    #Component: LEGACY
    #CharLimit: 250
    #Context: Settings toggle description for use your activity (CharLimit autocalculated to 250)`
  }
});
function MarketingTrackingPreferencesModal({
  close,
  onPress,
  isToggled,
  setIsToggled
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const handleSigninClick = useCallback(() => {
    setSigninRedirect('/settings/privacy-rights');
    window.location.href = '/signin';
  }, []);
  return /*#__PURE__*/jsx(Modal, {
    children: /*#__PURE__*/jsxs(StyledModalContainer, {
      children: [/*#__PURE__*/jsx(ModalHeader, {
        title: /*#__PURE__*/jsx(StyledText, {
          size: "medium",
          weight: "bold",
          children: formatMessage(messages.title)
        }),
        center: true,
        close: close
      }), /*#__PURE__*/jsx(StyledModalBody, {
        children: /*#__PURE__*/jsxs(VStack, {
          gap: 4,
          spacingBottom: 2,
          children: [/*#__PURE__*/jsx(Text, {
            color: "light",
            children: formatMessage(messages.description, {
              a: content => [/*#__PURE__*/jsx(Link, {
                href: "/signin",
                color: "accent",
                onClick: handleSigninClick,
                children: content
              })]
            })
          }), /*#__PURE__*/jsxs(HStack, {
            gap: 3,
            children: [/*#__PURE__*/jsx(Text, {
              children: formatMessage(messages.toggleTitle, {
                br: () => [/*#__PURE__*/jsx("br", {})]
              })
            }), /*#__PURE__*/jsx(Toggler, {
              toggled: isToggled,
              disabled: false,
              onToggle: setIsToggled
            })]
          }), /*#__PURE__*/jsx(Text, {
            size: "medium",
            children: formatMessage(messages.toggleDescription, {
              learnMoreLink: content => [/*#__PURE__*/jsx(StyledLink, {
                color: "accent",
                href: "https://help.coinbase.com/en/coinbase/privacy-and-security/data-privacy/performance-tracking",
                openInNewTab: true,
                children: content
              }, "one")]
            })
          })]
        })
      }), /*#__PURE__*/jsx(HStack, {
        spacingVertical: 1,
        spacingHorizontal: 2,
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        children: /*#__PURE__*/jsx(StyledButton, {
          block: false,
          onPress: onPress,
          variant: "primary",
          children: formatMessage(messages.save)
        })
      })]
    })
  });
}
const StyledModalContainer = styled(ModalContainer)`
  max-width: 612px;
  max-height: 410px;
  border-radius: 8px;

  height: fit-content;

  @media (${devices.phone}) {
    max-width: 366px;
    max-height: 492px;
  }
`;
const StyledText = styled(Text)`
  @media (${devices.phone}) {
    text-align: center;
    align-items: center;
    word-wrap: break-word;
    padding: 20px;
  }
`;
const StyledModalBody = styled(ModalBody)`
  flex-direction: column;
  letter-spacing: 0em;
  text-align: left;
  border-bottom: ${theme.border.border};
`;
const StyledLink = styled(Link)`
  font-size: ${theme.fontSize.medium};
`;
const StyledButton = styled(Button)`
  height: 56px;
  width: 105px;
  border-radius: 100px;
  padding: 16px 32px;
`;
const MarketingTrackingPreferencesModal$1 = /*#__PURE__*/memo(MarketingTrackingPreferencesModal);
export { MarketingTrackingPreferencesModal$1 as default };
//# sourceMappingURL=MarketingTrackingPreferencesModal.js.map
